import { render, staticRenderFns } from "./BuildingDetailSummary.vue?vue&type=template&id=a9af439e"
import script from "./BuildingDetailSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingDetailSummary.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports